import http from '@/http'
const URL = '/admin/seating'

export const list = async (params) => {
  const list = (await http.get(URL, { params: params }))
  return list
}

export const listParticipants = async (params) => {
  const list = (await http.get(URL + `/${params.id}/participants`, { params: params }))
  return list
}

export const show = async (id) => {
  let one = null
  if (id) {
    // CORRIGIDO: Adicionado .seatable para trazer participantes
    one = (await http.get(URL + `/${id}?include=areas.seats.seatable`))
  }
  return one
}

export const saveSeat = (payload) => {
  if (payload.id) {
    return http.patch(URL + `/${payload.id}`, payload)
  }
  return http.post(URL, payload)
}

export const saveArea = (payload) => {
  return http.patch(URL + `/${payload.seating_id}/area/${payload.id}`, payload)
}

export const deleteArea = async (seatingId, areaId) => {
  return http.delete(URL + `/${seatingId}/area/${areaId}`)
}

// NOVO: Alocar participante em assento
export const seatParticipant = (seatingId, areaId, payload) => {
  return http.post(URL + `/${seatingId}/area/${areaId}/seat`, payload)
}

// NOVO: Remover participante do assento
export const unseatParticipant = (seatingId, areaId, payload) => {
  return http.post(URL + `/${seatingId}/area/${areaId}/unseat`, payload)
}

export const createArea = (seatingId, data) => {
  return http.post(`/admin/seating/${seatingId}/areas`, data)
}

export const deleteSeat = async (id) => http.delete(URL + `/${id}`)
export const changeStatus = (payload) => http.put(URL + `/${payload}/status`)

export default {
  list,
  show,
  saveSeat,
  saveArea,
  deleteArea,
  seatParticipant,
  unseatParticipant,
  deleteSeat,
  changeStatus,
  listParticipants
}
